export default "__VITE_ASSET__DVlijaXF__"